import { render, staticRenderFns } from "./editLark.vue?vue&type=template&id=88d7a88a"
import script from "./editLark.vue?vue&type=script&lang=js"
export * from "./editLark.vue?vue&type=script&lang=js"
import style0 from "./editLark.vue?vue&type=style&index=0&id=88d7a88a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports